import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useQuery, type QueryKey} from '@github-ui/react-query'
import {useSearchParams} from '@github-ui/use-navigate'
import {updateUrl} from '@github-ui/history'
import {CommentsPreference, SplitPreference, type UserDiffViewSettings} from '../../types'

export const defaultUserDiffViewSettings: UserDiffViewSettings = {
  splitPreference: 'split',
  lineSpacing: 'relaxed',
  commentsPreference: CommentsPreference.Visible,
}

export function userDiffViewSettingsKey(): QueryKey {
  return [PageData.diffViewUserSettings]
}

export function useUserDiffViewSettingsData(initialData?: UserDiffViewSettings) {
  const queryKey = userDiffViewSettingsKey()

  return useQuery<UserDiffViewSettings>({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    queryFn: async () => {
      return initialData ? initialData : defaultUserDiffViewSettings
    },
    initialData,
    staleTime: Infinity,
  })
}

export function updateQueryParam(paramName: string, value: string) {
  const url = new URL(window.location.href, window.location.origin)

  if (value) {
    const encodedValue = encodeURIComponent(value)
    url.searchParams.set(paramName, encodedValue)
  } else {
    url.searchParams.delete(paramName)
  }
  updateUrl(url.toString())
}

export function useSplitViewPreference(defaultPreference: SplitPreference): SplitPreference {
  let splitPreference = defaultPreference

  const [searchParams] = useSearchParams()
  const splitPreferenceParam = searchParams.get('diff')

  if (splitPreferenceParam === 'split' || splitPreferenceParam === 'unified') {
    splitPreference = splitPreferenceParam
  }

  return splitPreference
}

export function useWhitespacePreference(defaultPreference: boolean): boolean {
  let hideWhitespace = defaultPreference

  const [searchParams] = useSearchParams()
  const whitespaceParam = searchParams.get('w')

  if (whitespaceParam === '1') {
    hideWhitespace = true
  } else if (whitespaceParam === '0') {
    hideWhitespace = false
  }

  return hideWhitespace
}
